const Icons = {
    Calendar: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.75 4.75V0.75M13.75 4.75V0.75M5.76 7.75H5.75M5.76 10.75H5.75M5.76 13.75H5.75M9.76 10.75H9.75M9.76 7.75H9.75M13.76 10.75H13.75M9.76 13.75H9.75M13.76 7.75H13.75M3.75 18.75H15.75C17.4069 18.75 18.75 17.4069 18.75 15.75V5.75C18.75 4.09315 17.4069 2.75 15.75 2.75H3.75C2.09315 2.75 0.75 4.09315 0.75 5.75V15.75C0.75 17.4069 2.09315 18.75 3.75 18.75Z" stroke="#DB9E21" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
};

export default Icons;
